
import { StationConfigLogEntry } from '@/api/dtos/LogEntry.schema'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class StationConfigLogEntryContent extends Vue {
  @Prop()
  logEntry!: StationConfigLogEntry
}
